import { createFileRoute } from "@tanstack/react-router";
import UserProfilePage from "@/pages/UserProfilePage";

export const Route = createFileRoute("/$leaid/_error-wrapper/profile")({
  component: UserProfilePage,
});
